import { sentryInit, sentryRootOptions } from "./lib/sentry";
import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { ReactFlowProvider } from "@xyflow/react";
import { inferInterviewContext, TAG } from "./lib/sentry";

sentryInit();

const container = document.getElementById("root");
const root = createRoot(container, sentryRootOptions());

const beforeCapture = (scope) => {
  const interview = inferInterviewContext();
  scope.setTag(TAG.INTERVIEW_MODE, interview.mode);
  scope.setTag(TAG.INVITE_ID, interview.id);
};

root.render(
  <Sentry.ErrorBoundary beforeCapture={beforeCapture}>
    <React.StrictMode>
      <Provider store={store}>
        <ReactFlowProvider>
          <App />
        </ReactFlowProvider>
      </Provider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
